module.exports = __webpack_public_path__ + "img/logoWW.625dfb43.png";